import { Lightbulb, Eye, Rocket, Users, type LucideIcon } from 'lucide-react';

// ── Timeline ──

export interface TimelineItem {
  year: string;
  title: string;
  description: string;
  gradient: string;
}

export const timelineItems: TimelineItem[] = [
  {
    year: '2023',
    title: 'Fundación',
    description:
      'Nació como un proyecto para resolver los desafíos de pricing en Bolivia. Un equipo pequeño con una gran visión: que ninguna empresa pierda dinero por no tener las herramientas adecuadas.',
    gradient: 'from-blue-500 to-cyan-400',
  },
  {
    year: '2024',
    title: 'Crecimiento',
    description:
      'Expandimos nuestro alcance a múltiples industrias y lanzamos el asistente de IA integrado. Pasamos de 10 a más de 200 empresas activas en la plataforma.',
    gradient: 'from-violet-500 to-purple-400',
  },
  {
    year: '2025',
    title: 'Expansión Regional',
    description:
      'Comenzamos a servir empresas en toda Latinoamérica: Perú, Colombia, Chile, México y más. Alianzas estratégicas con distribuidores regionales.',
    gradient: 'from-emerald-500 to-green-400',
  },
  {
    year: '2026',
    title: 'Innovación Continua',
    description:
      'Dynamic pricing, integración con SAP, analytics avanzado y scrapers de competencia. La plataforma más completa de pricing intelligence en la región.',
    gradient: 'from-orange-500 to-amber-400',
  },
];

// ── Values ──

export interface ValueItem {
  icon: LucideIcon;
  title: string;
  description: string;
  gradient: string;
}

export const values: ValueItem[] = [
  {
    icon: Lightbulb,
    title: 'Innovación',
    description:
      'Buscamos constantemente nuevas formas de resolver problemas complejos de pricing con tecnología de vanguardia e inteligencia artificial.',
    gradient: 'from-blue-500 to-cyan-400',
  },
  {
    icon: Eye,
    title: 'Transparencia',
    description:
      'Creemos en la claridad total: precios justos, comunicación abierta y datos accesibles para que nuestros clientes tomen decisiones informadas.',
    gradient: 'from-violet-500 to-purple-400',
  },
  {
    icon: Rocket,
    title: 'Impacto',
    description:
      'Cada feature que construimos está diseñada para generar un impacto real y medible en los resultados comerciales de nuestros clientes.',
    gradient: 'from-emerald-500 to-green-400',
  },
  {
    icon: Users,
    title: 'Colaboración',
    description:
      'Trabajamos codo a codo con nuestros clientes. Sus desafíos son nuestros desafíos, y su éxito es nuestra mejor métrica.',
    gradient: 'from-orange-500 to-amber-400',
  },
];

// ── Team ──

export interface TeamMember {
  name: string;
  role: string;
  bio: string;
  initials: string;
  gradient: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: 'Alejandro Mendoza',
    role: 'CEO & Co-Founder',
    bio: 'Ex-consultor de McKinsey con 12 años de experiencia en estrategia de precios para empresas Fortune 500 en Latam.',
    initials: 'AM',
    gradient: 'from-blue-500 to-violet-500',
  },
  {
    name: 'Valentina Rojas',
    role: 'CTO & Co-Founder',
    bio: 'Ingeniera de software con background en Google y MercadoLibre. Apasionada por construir productos escalables con IA.',
    initials: 'VR',
    gradient: 'from-violet-500 to-purple-500',
  },
  {
    name: 'Santiago Herrera',
    role: 'Head of Product',
    bio: 'Product manager con experiencia en fintech y SaaS B2B. Obsesionado con la experiencia de usuario y la simplicidad.',
    initials: 'SH',
    gradient: 'from-cyan-500 to-blue-500',
  },
  {
    name: 'Carolina Paz',
    role: 'Head of Sales',
    bio: 'Líder comercial con 8 años en ventas enterprise en Latam. Conoce los desafíos de pricing de primera mano.',
    initials: 'CP',
    gradient: 'from-emerald-500 to-green-500',
  },
  {
    name: 'Diego Fernández',
    role: 'Lead Engineer',
    bio: 'Full-stack developer especializado en sistemas distribuidos. Previamente en Globant y Rappi.',
    initials: 'DF',
    gradient: 'from-orange-500 to-amber-500',
  },
  {
    name: 'Lucía Vargas',
    role: 'Head of Customer Success',
    bio: 'Experta en onboarding y retención de clientes SaaS. Su misión: que cada cliente alcance su máximo potencial con la plataforma.',
    initials: 'LV',
    gradient: 'from-pink-500 to-rose-500',
  },
];
